exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".src-components-shared-ImageUpload-clearButton{width:100%;max-width:200px;min-width:200px}.src-components-shared-ImageUpload-previewContainer{height:200px}.src-components-shared-ImageUpload-imageWrap{vertical-align:middle;min-width:200px;min-height:200px}", ""]);

// exports
exports.locals = {
	"clearButton": "src-components-shared-ImageUpload-clearButton",
	"previewContainer": "src-components-shared-ImageUpload-previewContainer",
	"imageWrap": "src-components-shared-ImageUpload-imageWrap"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"modules":true,"localIdentName":"[path][local]"}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./node_modules/sass-loader/dist/cjs.js!./src/components/shared/ImageUpload/styles.scss
// module id = ./node_modules/css-loader/index.js?{"importLoaders":1,"modules":true,"localIdentName":"[path][local]"}!./node_modules/postcss-loader/lib/index.js?{"ident":"postcss","plugins":[null,null]}!./node_modules/sass-loader/dist/cjs.js!./src/components/shared/ImageUpload/styles.scss
// module chunks = 1